import React from 'react'
import {FormattedMessage} from 'react-intl'
import sizeImage from '../../assets/imgs/size.png'
// eslint-disable-next-line import/no-unresolved
import sizeImageDimension from '../../assets/imgs/size.png?size'
import ResponsiveImg from '../common/ResponsiveImg'
import styles from './Pricing.scss'

const Size = () => <div className="container py-5">
  <div className={['mb-3', styles.lead].join(' ')}>
    <FormattedMessage id="size.sizeTitle" defaultMessage="Car size table"/>
  </div>
  <ResponsiveImg
    url={sizeImage}
    className="mw-100 mb-3"
    caption="Size"
    dimension={sizeImageDimension}/>
</div>
Size.displayName = 'Size'
export default Size

